import { render, staticRenderFns } from "./status-form-notifications.vue?vue&type=template&id=44c3036e&scoped=true"
import script from "./status-form-notifications.vue?vue&type=script&lang=js"
export * from "./status-form-notifications.vue?vue&type=script&lang=js"
import style0 from "./status-form-notifications.vue?vue&type=style&index=0&id=44c3036e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c3036e",
  null
  
)

export default component.exports